import React, { useState } from "react";
// import { AllCommunityAnswearLike } from "../FetchAPI";
import axios from "axios";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";
// const userID = localStorage.getItem("userid");

export default function AnswersLikeDislikeBox({
  RendomTokenfetch,
  AnsID,
  QuesID,
  likeCount,
  likeStatus,
}) {
  const { userID } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const [like, setLike] = useState(likeStatus); // Use likeStatus from props
  const [totalLikes, setTotalLikes] = useState(Number(likeCount) || 0);
  const [likeColor, setLikeColor] = useState(
    likeStatus === "1" ? "#06f5e6" : "#606060"
  );

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLikeDislike = () => {
    if (localStorage.getItem("userid") === null) {
      NotifyMessageNoReload("Please login to After Like Answers.", "danger");
      navigate("/login", { state: { from: location.pathname } }); // Redirect to login with return path
      return;
    }

    const newLikeStatus = like === "0" ? "1" : "0";
    setLike(newLikeStatus);
    setLikeColor(newLikeStatus === "1" ? "#06f5e6" : "#606060");
    setTotalLikes((prev) => (newLikeStatus === "1" ? prev + 1 : prev - 1));

    const FetchcatService = async () => {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("question_id", QuesID);
      fdata.append("answer_id", AnsID);
      fdata.append("status", newLikeStatus);
      try {
        await axios
          .post(`${WebsiteAPIurl}answer_like`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data.Status === "1") {
              if (response.data.like_status === "1") {
                NotifyMessageNoReload(response.data.message, "success");
              }
              if (response.data.like_status === "0") {
                NotifyMessageNoReload(response.data.message, "danger");
              }
            }
            if (response.data.Status === "0") {
              NotifyMessageNoReload(response.data.message, "danger");
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchcatService();
  };

  if (loading) {
    //   return <APIDataFetchLoader />;
  }
  if (error) {
  }

  return (
    <>
      <p className="fw-600 mb-0 helpfullLinkBox" onClick={handleLikeDislike}>
        <span> Helpful?</span>
        <span>
          <i
            className="LinkDislinkBTN fa fa-thumbs-up mx-2"
            aria-hidden="true"
            style={{ color: likeColor }}
          ></i>
        </span>
        <span className="totalLike">{totalLikes}</span>
      </p>
    </>
  );
}
